import React from 'react'
import Api from '../Api/Api'

const ApiPage = () => {
  return <Api />
}

export default ApiPage
